"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTaskAndVariant = exports.getRunTrials = exports.getUserRuns = exports.formatDate = exports.queryUsers = exports.getVariants = exports.getTasks = exports.getOrganizations = void 0;
const firestore_1 = require("firebase/firestore");
const util_1 = require("./util");
const chunk_1 = __importDefault(require("lodash/chunk"));
const getOrganizations = ({ db, orgType, orgIds, pageLimit = 15, startAfterDocId, }) => __awaiter(void 0, void 0, void 0, function* () {
    let q;
    if (!orgIds) {
        if (startAfterDocId) {
            q = (0, firestore_1.query)((0, firestore_1.collection)(db, orgType), (0, firestore_1.orderBy)((0, firestore_1.documentId)()), (0, firestore_1.startAfter)(startAfterDocId), (0, firestore_1.limit)(pageLimit));
        }
        else {
            q = (0, firestore_1.query)((0, firestore_1.collection)(db, orgType), (0, firestore_1.orderBy)((0, firestore_1.documentId)()), (0, firestore_1.limit)(pageLimit));
        }
        const snapshot = yield (0, firestore_1.getDocs)(q);
        return snapshot.docs.map((doc) => {
            const docData = doc.data();
            docData.id = doc.id;
            return docData;
        });
    }
    let remainingOrgIds = orgIds.sort();
    if (startAfterDocId) {
        const startIndex = remainingOrgIds.indexOf(startAfterDocId) + 1;
        remainingOrgIds = remainingOrgIds.slice(startIndex, startIndex + pageLimit);
    }
    const orgs = [];
    const maxQueryDisjunctions = 10;
    for (const _orgsChunk of (0, chunk_1.default)(remainingOrgIds, maxQueryDisjunctions)) {
        q = (0, firestore_1.query)((0, firestore_1.collection)(db, orgType), (0, firestore_1.where)((0, firestore_1.documentId)(), 'in', _orgsChunk));
        const snapshot = yield (0, firestore_1.getDocs)(q);
        orgs.push(...snapshot.docs.map((doc) => {
            const docData = doc.data();
            docData.id = doc.id;
            return docData;
        }));
    }
    return orgs;
});
exports.getOrganizations = getOrganizations;
const getTasks = (db, requireRegistered = true) => __awaiter(void 0, void 0, void 0, function* () {
    let q;
    if (requireRegistered) {
        q = (0, firestore_1.query)((0, firestore_1.collection)(db, 'tasks'), (0, firestore_1.where)('registered', '==', true));
    }
    else {
        q = (0, firestore_1.query)((0, firestore_1.collection)(db, 'tasks'));
    }
    const tasksSnapshot = yield (0, firestore_1.getDocs)(q);
    const tasks = [];
    tasksSnapshot.forEach((doc) => {
        const docData = doc.data();
        tasks.push(Object.assign({ id: doc.id, image: docData.image, name: docData.name, description: docData.description, registered: docData.registered }, docData));
    });
    return tasks;
});
exports.getTasks = getTasks;
const getVariants = (db, requireRegistered = true) => __awaiter(void 0, void 0, void 0, function* () {
    const taskVariants = [];
    const tasks = yield (0, exports.getTasks)(db, requireRegistered);
    for (const task of tasks) {
        let q;
        if (requireRegistered) {
            q = (0, firestore_1.query)((0, firestore_1.collection)(db, 'tasks', task.id, 'variants'), (0, firestore_1.where)('registered', '==', true));
        }
        else {
            q = (0, firestore_1.query)((0, firestore_1.collection)(db, 'tasks', task.id, 'variants'));
        }
        const snapshot = yield (0, firestore_1.getDocs)(q);
        snapshot.forEach((doc) => {
            if (doc.id !== 'empty') {
                const docData = doc.data();
                taskVariants.push({
                    id: doc.id,
                    task,
                    variant: Object.assign({ id: doc.id, name: docData.name, params: docData.params, registered: docData.registered, lastUpdated: docData.lastUpdated }, docData),
                });
            }
        });
    }
    return taskVariants;
});
exports.getVariants = getVariants;
const queryUsers = (rootDoc, taskIds, variantIds) => __awaiter(void 0, void 0, void 0, function* () {
    const users = [];
    if (taskIds.length > 0) {
        let userQuery;
        if (variantIds.length > 0) {
            userQuery = (0, firestore_1.query)((0, firestore_1.collection)(rootDoc, 'users'), (0, firestore_1.where)('variants', 'array-contains-any', variantIds));
        }
        else {
            userQuery = (0, firestore_1.query)((0, firestore_1.collection)(rootDoc, 'users'), (0, firestore_1.where)('tasks', 'array-contains-any', taskIds));
        }
        const usersSnapshot = yield (0, firestore_1.getDocs)(userQuery);
        usersSnapshot.forEach((doc) => {
            const { districtIds, schoolIds, groupIds, classIds } = (0, util_1.getOrgs)(doc.data());
            users.push({
                roarUid: doc.id,
                districts: districtIds,
                schools: schoolIds,
                groups: groupIds,
                classes: classIds,
            });
        });
    }
    return users;
});
exports.queryUsers = queryUsers;
const formatDate = (date) => date === null || date === void 0 ? void 0 : date.toLocaleString('en-US');
exports.formatDate = formatDate;
const getUserRuns = (rootDoc, user, filters, taskIds, variantIds) => __awaiter(void 0, void 0, void 0, function* () {
    const runs = [];
    const { roarUid, districts, schools, classes, groups } = user;
    const filterOrgs = [
        (0, util_1.userHasSelectedOrgs)(districts, filters.districts),
        (0, util_1.userHasSelectedOrgs)(schools, filters.schools),
        (0, util_1.userHasSelectedOrgs)(classes, filters.classes),
        (0, util_1.userHasSelectedOrgs)(groups, filters.groups),
    ];
    const isUserSelected = filterOrgs.every((element) => element === true);
    if (isUserSelected) {
        let runsQuery;
        if (variantIds.length > 0) {
            runsQuery = (0, firestore_1.query)((0, firestore_1.collection)(rootDoc, 'users', roarUid, 'runs'), (0, firestore_1.where)('variantId', 'in', variantIds));
        }
        else {
            runsQuery = (0, firestore_1.query)((0, firestore_1.collection)(rootDoc, 'users', roarUid, 'runs'), (0, firestore_1.where)('taskId', 'in', taskIds));
        }
        const runsSnapshot = yield (0, firestore_1.getDocs)(runsQuery);
        runsSnapshot.forEach((doc) => {
            var _a, _b;
            const firestoreRun = doc.data();
            const runData = {
                roarUid: roarUid,
                runId: doc.id,
            };
            runData.timeStarted = (0, exports.formatDate)((_a = firestoreRun.timeStarted) === null || _a === void 0 ? void 0 : _a.toDate()) || null;
            runData.timeFinished = (0, exports.formatDate)((_b = firestoreRun.timeFinished) === null || _b === void 0 ? void 0 : _b.toDate()) || null;
            runData.task = { id: firestoreRun.taskId };
            runData.variant = { id: firestoreRun.variantId };
            runData.district = { id: firestoreRun.districtId };
            runData.school = { id: firestoreRun.schoolId };
            runData.class = { id: firestoreRun.classId };
            runData.group = { id: firestoreRun.groupId };
            delete firestoreRun.taskRef;
            delete firestoreRun.variantRef;
            delete firestoreRun.taskId;
            delete firestoreRun.variantId;
            delete firestoreRun.districtId;
            delete firestoreRun.schoolId;
            delete firestoreRun.classId;
            delete firestoreRun.groupId;
            delete firestoreRun.timeStarted;
            delete firestoreRun.timeFinished;
            runs.push(Object.assign(Object.assign({}, runData), firestoreRun));
        });
    }
    return runs;
});
exports.getUserRuns = getUserRuns;
const getRunTrials = (rootDoc, run) => __awaiter(void 0, void 0, void 0, function* () {
    const trialsQuery = (0, firestore_1.query)((0, firestore_1.collection)(rootDoc, 'users', run.roarUid, 'runs', run.runId, 'trials'));
    const trialsSnapshot = yield (0, firestore_1.getDocs)(trialsQuery);
    const trials = [];
    trialsSnapshot.forEach((doc) => {
        var _a, _b;
        const firestoreTrial = doc.data();
        const trialData = {
            roarUid: run.roarUid,
            runId: run.runId,
        };
        trialData.timeStarted = (0, exports.formatDate)((_a = firestoreTrial.timeStarted) === null || _a === void 0 ? void 0 : _a.toDate()) || null;
        trialData.timeFinished = (0, exports.formatDate)((_b = firestoreTrial.timeFinished) === null || _b === void 0 ? void 0 : _b.toDate()) || null;
        trialData.task = { id: firestoreTrial.taskId };
        trialData.variant = { id: firestoreTrial.variantId };
        trialData.district = { id: firestoreTrial.districtId };
        trialData.school = { id: firestoreTrial.schoolId };
        trialData.class = { id: firestoreTrial.classId };
        trialData.group = { id: firestoreTrial.groupId };
        delete firestoreTrial.taskId;
        delete firestoreTrial.variantId;
        delete firestoreTrial.districtId;
        delete firestoreTrial.schoolId;
        delete firestoreTrial.classId;
        delete firestoreTrial.groupId;
        delete firestoreTrial.timeStarted;
        delete firestoreTrial.timeFinished;
        trials.push(Object.assign(Object.assign({}, trialData), firestoreTrial));
    });
});
exports.getRunTrials = getRunTrials;
const getTaskAndVariant = ({ db, taskId, variantParams, }) => __awaiter(void 0, void 0, void 0, function* () {
    const taskRef = (0, firestore_1.doc)(db, 'tasks', taskId);
    const variantsCollectionRef = (0, firestore_1.collection)(taskRef, 'variants');
    const docSnap = yield (0, firestore_1.getDoc)(taskRef);
    if (docSnap.exists()) {
        const taskData = docSnap.data();
        // Check to see if variant exists already by querying for a match on the params.
        const q = (0, firestore_1.query)(variantsCollectionRef, (0, firestore_1.where)('params', '==', variantParams), (0, firestore_1.limit)(1));
        const querySnapshot = yield (0, firestore_1.getDocs)(q);
        let variantData;
        querySnapshot.forEach((docRef) => {
            variantData = Object.assign(Object.assign({}, docRef.data()), { id: docRef.id });
        });
        return {
            task: taskData,
            variant: variantData,
        };
    }
    return {
        task: undefined,
        variant: undefined,
    };
});
exports.getTaskAndVariant = getTaskAndVariant;
